const FeaturedSection = () => {
  const items = ["Boxing", "MissNation", "Marathon", "Banking", "KidsProgram"];

  return (
    <div className="bg-transparent w-full p-4 text-3xl">
      <div className="col gap-4 p-4 items-center overflow-hidden relative">
        <h2 className="playfair-display heading-1 mb-2 text-prime-red">
          Featured
        </h2>

        {/* Scrolling Content */}
        <div className="whitespace-nowrap overflow-hidden relative w-full">
          <div className="flex items-center gap-10 md:gap-14 lg:gap-16 text-zinc-500/80 animate-marquee">
            {/* Original Items + Duplicates for Infinite Loop */}
            {[...items, ...items].map((item, index) => (
              <p key={index} className="text-2xl md:text-3xl font-semibold">
                {item}
              </p>
            ))}
          </div>
        </div>

        {/* Decorative Blur (Keeps Edge Text Looking Clean) */}
        <div className="absolute left-0 top-0 w-14 lg:w-50 h-full bg-gradient-to-r from-prime-white to-prime-white  blur-md"></div>
        <div className="absolute right-0 top-0 w-14 lg:w-50 h-full bg-gradient-to-l from-prime-white to-prime-white blur-md"></div>
      </div>
    </div>
  );
};

export default FeaturedSection;
